<template>
  <!-- Table Container Card -->
  <b-card>

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="approvalRef"
      :busy="isBusy"
      :per-page="pageSize"
      :current-page="currentPage"
      :items="approvalList"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>
      <template #cell(initiatorName)="data">
        {{ data.value }}
      </template>

      <template #cell(amount)="data">
        {{ data.value ? toBalance(data.value) : '' }}
      </template>

      <template #cell(approvalStatus)="data">
        <b-badge
          pill
          :variant="getStatusColor(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template
        #cell(actions)="data"
      >
        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="onSelectApprovalItem(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $t('View') }} </span>
            </b-dropdown-item>

            <!-- <b-dropdown-item @click="onSelectApprovalItem(data.item)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">Rework Required</span>
            </b-dropdown-item> -->

            <b-dropdown-item
              v-if="data.item.approvalStatus.trim().toLowerCase() !== 'pending'"
              @click="onViewApprovalHistory(data.item)"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $t('View History') }} </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="$t('Cancel')"
      ok-only
      ok-variant="outline-secondary"
      centered
      size="xl"
    >
      <div class="text-left mb-3">
        <b-row>
          <b-col
            v-for="(item, index) in approvalTableItems"
            :key="index"
            md="4"
            class="mb-1"
          >
            <h5 class="font-weight-bolder">
              {{ item.label }}
            </h5>

            <p v-if="item.label !== 'Approval Status'">
              {{ item.text }}
            </p>

            <b-badge
              v-else
              pill
              :variant="getStatusColor(item.text)"
            >
              {{ item.text }}
            </b-badge>
          </b-col>
        </b-row>
      </div>

      <SwitchButton
        v-if="!fallbackToDefault"
        v-model="enableRecordHistory"
        :label="$t('Show Record History')"
        name="record-history"
      />

      <div v-if="enableRecordHistory">
        <div v-if="!isPostingType && isPaymentSchedule">
          <b-table
            ref="approvalRef"
            :busy="isBusy"
            :per-page="pageSize"
            :current-page="currentPage"
            :items="paymentScheduleApprovalItems"
            responsive
            :fields="translatedPaymentScheduleApprovalHeader"
            primary-key="id"
            show-empty
            :empty-text="$t('No records available')"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>

          </b-table>

          <TablePagination
            v-model="currentPage"
            :from="approvalFom"
            :to="approvalTo"
            :total-rows="approvalTotalEntries"
            :per-page="perPage"
          />
        </div>
        <div v-else-if="!isPostingType">
          <b-table
            ref="approvalTable"
            :items="approvalItems"
            :per-page="pageSize"
            :current-page="currentPage"
            responsive
            :fields="translatedApprovalItemHeader"
            primary-key="id"
            show-empty
            :empty-text="$t('No result found')"
            class="position-relative approval-table"
          >
            <template #cell(description)="data">
              {{ addSpaceToString(data.value) }}
            </template>

            <template #cell(previousData)="data">
              <b
                :class="data.item.previousData !== data.item.newData ? 'text-danger break' : 'break'"
                style=""
              >{{ data.value }}</b>
            </template>

            <template #cell(newData)="data">
              <b
                :class="data.item.previousData !== data.item.newData ? 'text-success break' : 'break'"
              >{{ data.value }}</b>
            </template>
          </b-table>

        </div>

        <div v-else>
          <b-table
            ref="approvalRef"
            :busy="isBusy"
            :per-page="postingApprovalPagination.perPage"
            :current-page="postingApprovalPagination.currentPage"
            :items="postingApprovalItems"
            responsive
            :fields="translatedpostingApprovalHeader"
            primary-key="id"
            show-empty
            :empty-text="$t('No records available')"
            class="position-relative"
          >
            <template #cell(SN)="data">
              {{ getPageNumberIndex(data.index) }}
            </template>

          </b-table>

          <TablePagination
            v-model="postingApprovalPagination.currentPage"
            :from="postingApprovalFrom"
            :to="postingApprovalTo"
            :total-rows="postingApprovalPagination.totalEntries"
            :per-page="postingApprovalPagination.perPage"
          />

        </div>

        <div
          v-if="isAbridgedLoan || isLoanAccount || isDisburseLoanAccount"
          class="d-flex mt-1 mb-3 justify-content-center"
        >
          <Button
            :label="$t('View Repayment Schedule')"
            variant="success"
            :loading="isLoadingRepaymentSchedule"
            :disabled="isDisabledRepaymentSchedule"
            size="md"
            @click="onViewRepaymentSchedule"
          />

          <Button
            :label="$t('View Document File')"
            :loading="isLoadingDocumentFile"
            :disabled="isDisabledDocumentFile"
            size="md"
            class="ml-2"
            variant="success"
            @click="viewDocumentFileAction"
          />
        </div>
      </div>
      <div
        v-if="isComponentLoading"
        class="d-flex justify-content-center align-items-center"
        style="min-height: 300px; height: 100%;"
      >
        <b-spinner
          variant="primary"
          :label="$t('Loading form...')"
        />
      </div>
      <component
        :is="currentFormComponent"
        v-if="!fallbackToDefault"
        v-bind="formProps"
        @update="handleFormUpdate"
      />

      <validation-observer
        v-if="hasBeenApproved"
        ref="approvalRules"
        rules=""
      >
        <b-form>
          <b-row>
            <b-col md="12">
              <TextAreaField
                id="notes"
                v-model="approvalFormData.notes"
                :label="$t('Notes')"
                :placeholder="$t('Enter note')"
                :error-name="$t('Note')"
                :rules="isApprovalNoteRequired"
                rows="5"
              />
            </b-col>
          </b-row>

          <div class="d-flex mt-1 mb-3 justify-content-center">
            <Button
              :label="$t('Approve')"
              variant="success"
              :loading="approvalButtonStatus.isLoadingApprove"
              :disabled="approvalButtonStatus.isDisableApprove"
              size="md"
              @click="handleSubmit(2)"
            />

            <Button
              :label="$t('Decline')"
              :loading="approvalButtonStatus.isLoadingReJect"
              :disabled="approvalButtonStatus.isDisableReject"
              size="md"
              class="ml-2"
              variant="danger"
              @click="handleSubmit(3)"
            />
            <Button
              v-if="selectedApprovalItem && reworkAllowedPages.includes(getPageKeyToEvaluate(selectedApprovalItem))"
              :label="$t('Rework Required')"
              :loading="approvalButtonStatus.isLoadingReWork"
              :disabled="approvalButtonStatus.isDisableReWork"
              size="md"
              class="ml-2"
              variant="warning"
              @click="handleSubmit(5)"
            />
          </div>
        </b-form>
      </validation-observer>

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchApprovals"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Request ID -->
        <b-col md="6">
          <InputField
            id="requestID"
            v-model="filter.reference"
            :label="$t('Request ID')"
            :placeholder="$t('Enter request ID')"
            type="text"
          />
        </b-col>
        <!-- Request ID -->

        <!-- Function Name -->
        <b-col md="6">
          <SelectField
            id="function-name"
            v-model="filter.permissionID"
            :label="$t('Function Name')"
            :placeholder="$t('Select')"
            :options="functionNameOptions"
            :reduce="option => option.value"
            item="label"
            :loading="isLoadingFunctionName"
          />
        </b-col>
        <!-- Function Name -->

        <!-- Initiator Name -->
        <b-col md="6">
          <SelectField
            id="initiator-name"
            v-model="filter.initiatorId"
            :label="$t('Initiator Name')"
            :placeholder="$t('Select')"
            :options="usersOptions"
            :reduce="option => option.value"
            item="label"
            :loading="isLoadingInitiatorName"
          />
        </b-col>
        <!-- Initiator Name -->

        <!-- Initiator Branch -->
        <b-col md="6">
          <SelectField
            id="initiator-branch"
            v-model="filter.initiatorBranchCode"
            :label="$t('Initiator Branch')"
            :placeholder="$t('Select')"
            :options="branchOptions"
            :reduce="option => option.value"
            item="label"
          />
        </b-col>
        <!-- Initiator Branch -->

        <!--Date Logged -->
        <b-col md="6">
          <DatePickerField
            id="date-logged"
            v-model="filter.dateCreated"
            :placeholder="$t('Select date')"
            :label="$t('Date Logged')"
            :config="datePickerConfig"
            :disabled="isReadonly"
          />
        </b-col>
        <!-- Date Logged -->

        <!-- Approval Status -->
        <b-col md="6">
          <SelectField
            id="sanctioned-by"
            v-model="filter.approvalStatus"
            :label="$t('Approval Status')"
            :placeholder="$t('Select')"
            :options="translatedApprovalStatusOptions"
            :reduce="option => option.value"
            item="label"
          />
        </b-col>
        <!-- Approval Status -->

      </b-row>
    </b-modal>
    <!-- Filter modal -->

    <!-- View Repayment Schedule -->
    <b-modal
      id="repayment-schedule-modal"
      ref="repaymentScheduleModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('View Repayment Schedule')"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <TableEntries
              v-model="repaymentSchedulePagination.perPage"
              :options="perPageOptions"
            />

          </b-col>
        </b-row>
      </div>

      <b-table
        ref="repaymentScheduleModalTable"
        select-mode="single"
        :items="repaymentSchedules"
        responsive
        no-local-sorting
        :fields="translatedRepaymentScheduleTableHeaders"
        :per-page="repaymentSchedulePagination.perPage"
        :current-page="repaymentSchedulePagination.currentPage"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getPageNumber(data.index) }}
        </template>
      </b-table>

      <TablePagination
        v-model="repaymentSchedulePagination.currentPage"
        :from="repaymentFrom"
        :to="repaymentTo"
        :total-rows="repaymentSchedulePagination.totalEntries"
        :per-page="repaymentSchedulePagination.perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- View Repayment Schedule -->

    <!-- Document File -->
    <b-modal
      id="modal-document-files"
      ref="my-document-files"
      :ok-title="$t('Cancel')"
      ok-only
      :cancel-title="$t('Cancel')"
      ok-variant="outline-secondary"
      centered
      size="md"
      :title="$t('View Document Files')"
    >
      <!-- <b-row class="match-height"> -->
      <b-form>
        <b-row
          v-for="(item, index) in documentsFormData"
          :id="index"
          :key="index"
          class="mb-2 match-height"
        >
          <b-col md="7">
            <SelectField
              id="document-type"
              v-model="item.type"
              :reduce="option => option.value"
              :label="$t('Document Type')"
              :placeholder="$t('Select')"
              :options="documentTypeOptions"
              item="label"
              readonly
            />
          </b-col>
          <b-col
            md="7"
          >
            <label> {{ $t('Upload Documents') }} </label>

            <div class="upload-image">
              <b-form-group>
                <b-form-file
                  :placeholder="$t('Choose a file or drop it here...')"
                  :drop-placeholder="$t('Drop file here...')"
                  accept="image/jpeg, image/png, image/jpg, application/pdf, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  plain
                  disabled
                  @change="onDocumentsUpload(index, $event)"
                />
                <div
                  v-if="!item.url"
                  class="upload-instruction"
                >
                  <h4> {{ $t('Upload Document File') }} </h4>
                  <p> {{ $t('Drag & drop file or choose from your device to upload') }} </p>
                  <p class="format">
                    {{ $t('Format accepted (jpg, png, jpeg, docx, pdf)') }}
                  </p>
                </div>
                <div v-else>
                  <div v-if="item.fileExtension === 'png'|| item.fileExtension === 'jpeg'|| item.fileExtension === 'jpg'">
                    <b-img
                      :src="item.url"
                      block
                      rounded
                      width="250px"
                      height="250px"
                    />
                  </div>
                  <div
                    v-else-if="item.fileExtension === 'pdf'"
                  >
                    <b-img
                      :src="pdfIcon"
                      block
                      rounded
                      width="250px"
                      height="250px"
                    />
                  </div>
                  <div
                    v-else-if="item.fileExtension === 'vnd'"
                  >
                    <b-img
                      :src="wordIcon"
                      block
                      rounded
                      width="250px"
                      height="250px"
                    />
                  </div>
                  <div
                    v-else
                  >
                    <b-img
                      src=""
                    />
                  </div>
                  <div
                    v-if="item.url"
                    class="view-details"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="20"
                      class="text-primary"
                      @click="viewDocumentFile(item.url, item.fileName, item.fileExtension)"
                    />
                  </div>
                </div>
              </b-form-group>
            </div>
          </b-col>
          <b-col
            v-if="item.url"
            md="4"
            class="mt-0"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="ml-0"
              @click="handleDownload(item.url)"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-25"
              />
              <span> {{ $t('Download') }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- Document File -->

    <b-modal
      id="view-avatar-modal"
      ref="avatarModal"
      no-close-on-backdrop
      :ok-title="$t('Download File')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="viewDocumentModalTitle"
      @hidden="resetDocumentModal"
      @cancel="resetDocumentModal"
      @ok="handleDownload(viewDocumentData)"
    >
      <div class="m-2 text-center">
        <b-row>
          <b-col cols="12">
            <div v-if="fileExtension === 'png'|| fileExtension === 'jpeg'|| fileExtension === 'jpg'">
              <b-img
                :src="viewDocumentData"
                block
                fluid
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'pdf'">
              <b-img
                :src="pdfIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else-if="fileExtension === 'vnd'">
              <b-img
                :src="wordIcon"
                block
                width="250px"
                height="250px"
                rounded
              />
            </div>
            <div v-else>
              <b-img
                src=""
              /></div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- View Approval History -->
    <b-modal
      id="approval-history-modal"
      ref="approvalHistoryModal"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="xl"
      :title="$t('Approval History')"
    >

      <b-table
        ref="approvalHistoryTable"
        :items="approvalHistory"
        responsive
        no-local-sorting
        :fields="translatedApprovalHistoryHeader"
        primary-key="id"
        show-empty
        :empty-text="$t('No result found')"
        class="position-relative mt-2"
      >
        <template #cell(SN)="data">
          {{ getPageNumber(data.index) }}
        </template>
        <template #cell(approvalStatus)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(dateLastModified)="data">
          {{ data.value ? toDateWithYear(data.value) : '' }}
        </template>

        <template #cell(dateApproved)="data">
          {{ data.value ? toDateWithTime(data.value) : "" }}
        </template>

      </b-table>

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- View Approval History -->
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BSpinner, BModal, BBadge, BImg, BForm, BDropdownItem, BDropdown, BButton, BFormGroup, BFormFile,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { ValidationObserver } from 'vee-validate'
import { formatFullName } from '@/helpers/misc'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { operationPermissions } from '@/helpers/permissions'
import { toBalance, toKobo } from '@/helpers/formatAmount'
import InputField from '../../../forms/InputField.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import SelectField from '../../../forms/SelectField.vue'
import { operationType } from '../../../../helpers/data'
import addSpaceToString from '../../../../helpers/addSpaceToString'
import {
  toYearWithDate, toDateWithTime, toDateWithMonth, toDateWithYear,
} from '../../../../helpers/formatDate'
import Button from '../../../components/button/Button.vue'
import TextAreaField from '../../../forms/TextAreaField.vue'
import getStatusColor from '../../../../helpers/getStatusColor'
import SwitchButton from '../../../components/switch/Switch.vue'
import { PROCESS_FUNCTIONS } from '@/helpers/constants'

const documentTypes = [
  { value: 1, label: 'Signature Specimen' },
  { value: 2, label: 'Proof Of Address' },
  { value: 3, label: 'Driver’s License' },
  { value: 4, label: 'National Identity Card' },
  { value: 5, label: 'Voters Card' },
  { value: 6, label: 'National Identity Number' },
  { value: 7, label: 'International Passport' },
  { value: 8, label: 'Passport Photograph' },
  { value: 9, label: 'Reference Letter' },
  { value: 10, label: 'Guarantor’s Letter' },
  { value: 11, label: 'Loan Application Form' },
  { value: 12, label: 'Credit Bureau Form' },
  { value: 13, label: 'Others' },
]

const approvalStatusOptions = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Awaiting Next Reviewer', value: 'AwaitingNextReviewer' },
  { label: 'Rework Required', value: 'ReworkRequired' },
]

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    BForm,
    BFormGroup,
    BImg,
    BFormFile,
    ValidationObserver,
    TableEntries,
    Button,
    BTable,
    TablePagination,
    DatePickerField,
    BModal,
    BSpinner,
    FullScreenSpinner,
    InputField,
    BDropdownItem,
    BDropdown,
    SelectField,
    TextAreaField,
    SwitchButton,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert],
  data() {
    return {
      toDateWithYear,
      isLoadingRepaymentSchedule: false,
      isDisabledRepaymentSchedule: false,
      isLoadingDocumentFile: false,
      isDisabledDocumentFile: false,
      toBalance,
      showSpinner: false,
      isLoadingFunctionName: false,
      isLoadingInitiatorName: false,
      enableRecordHistory: true,
      approvalButtonStatus: {
        isLoadingApprove: false,
        isDisableApprove: false,
        isLoadingReJect: false,
        isDisableReject: false,
        isLoadingReWork: false,
        isDisableReWork: false,
      },
      isApprovalNoteRequired: '',
      isComponentLoading: false,
      toYearWithDate,
      toDateWithTime,
      getStatusColor,
      isReadonly: false,
      isFullName: false,
      statusFilter: '',
      showFormErrorAlert: false,
      sortBy: 'dateLogged',
      required,
      addSpaceToString,
      hasBeenApproved: false,
      datePickerConfig: {
        dateFormat: 'Y-m-d',
      },
      operationTypeOptions: operationType,
      modalTitle: this.$t('Audit Trail'),
      sortDesc: false,
      postingApprovalHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'branchCode', sortable: true, label: 'Branch Code' },
        { key: 'debit', sortable: true, label: 'Debit Amount' },
        { key: 'credit', sortable: true, label: 'Credit Amount' },
        { key: 'instrumentNumber', sortable: true, label: 'Instrument Number' },
        { key: 'narration', sortable: true, label: 'Narration' },
        { key: 'entryCode', sortable: true, label: 'Entry Code' },
      ],
      paymentScheduleApprovalHeader: [
        { key: 'SN', label: 'S/N' },
        { key: 'paymentDate', sortable: true, label: 'Payment Date' },
        { key: 'principal', sortable: true, label: 'Principal' },
        { key: 'interest', sortable: true, label: 'Interest' },
        { key: 'fee', sortable: true, label: 'Fee' },
      ],
      isPaymentSchedule: false,
      paymentScheduleApprovalItems: [],

      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'requestId', sortable: true, label: 'Request ID' },
        { key: 'functionName', sortable: true, label: 'Function Name' },
        { key: 'initiatorName', sortable: true, label: "Initiator's Name" },
        { key: 'initiatorBranch', sortable: true, label: "Initiator's Branch" },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'amount', sortable: true, label: 'Amount' },
        { key: 'levelAndDescription', sortable: true, label: 'Level and Description' },
        { key: 'approvalStatus', sortable: true, label: 'Approval Status' },
        { key: 'dateLogged', sortable: true, label: 'Date Logged' },
        { key: 'notes', sortable: true, label: 'Comment' },
        { key: 'sanctionedBy', sortable: true, label: 'Sanctioned By' },
        { key: 'actions', label: 'Actions' },
      ],
      approvalItemHeader: [
        { key: 'description', sortable: false, label: 'Description' },
        { key: 'previousData', sortable: false, label: 'Previous Data' },
        { key: 'newData', sortable: false, label: 'New Data' },
      ],
      approvalHistoryHeader: [
        { key: 'approver', sortable: false, label: 'Approver' },
        { key: 'approverEmail', sortable: false, label: 'Approver Email' },
        { key: 'levelAndDescription', sortable: false, label: 'Level and Description' },
        { key: 'notes', sortable: false, label: 'Comment' },
        { key: 'approvalStatus', sortable: false, label: 'Approval Status' },
        { key: 'dateApproved', sortable: false, label: 'Date Approved' },
      ],
      approvalHistory: [],
      approvalItems: [],
      buttonLabel: this.$t('Save'),
      accountOfficerFormData: {
        lastName: '',
        otherNames: '',
        staffID: '',
        phoneNumber: '',
        accessLevel: null,
        gender: null,
        address: '',
        branchCode: '',
        status: '',
        id: '',
      },
      repaymentSchedules: [],
      exportableRepaymentSchedules: [],
      paymentSchedules: [],
      repaymentScheduleTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'paymentDate', label: 'Repayment Date' },
        { key: 'principal', label: 'Principal' },
        { key: 'interest', label: 'Interest' },
        { key: 'fee', label: 'Loan Fee' },
        { key: 'totalRepayment', label: 'Total Repayment' },
        { key: 'paymentStatus', label: 'Payment Status' },
      ],
      repaymentSchedulePagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      postingApprovalPagination: {
        currentPage: 1,
        totalEntries: 0,
        perPage: 10,
        pageSize: 0,
      },
      filter: {
        reference: null,
        permissionID: null,
        initiatorName: null,
        initiatorBranchID: null,
        approverID: null,
        dateCreated: null,
        approvalStatus: null,
      },
      approvalFormData: {
        id: '',
        approvalStatus: null,
        notes: '',
      },
      sanctionedByOptions: [],
      functionNameOptions: [],
      usersOptions: [],
      approvalList: [],
      oldData: [],
      newData: [],
      title: '',
      menuName: '',
      approvalTableItems: [],
      isPostingType: false,
      postingApprovalItems: [],
      documentIdentifier: '',
      documentsFormData: [{
        type: '',
        url: '',
        file: '',
      }],
      viewDocumentData: '',
      viewDocumentModalTitle: '',
      fileExtension: '',
      isAbridgedLoan: false,
      isLoanAccount: false,
      isDisburseLoanAccount: false,
      repaymentScheduleData: {},
      disburseLoanAmount: 0,
      formData: '',
      fallbackToDefault: true,
      currentFormComponent: null,
      currentApprovalItem: {},
      formProps: {},
      entityType: null,
      componentCache: {},
      formRegistry: {
        accountOfficer: () => import('../../account-management/account-officer/AccountOfficerForm.vue'),
        pfiOnboarding: () => import('../../../forms/reusables/PFIOnboardingForm.vue'),
        dueDiligence: () => import('../../../forms/reusables/DueDiligence.vue'),
        creditLimit: () => import('../../../forms/reusables/CreditLimit.vue'),
        KYCInformation: () => import('../../../forms/reusables/KYCInformation.vue'),
        masterFinancingAgreement: () => import('../../../forms/reusables/MasterFinancingAgreement.vue'),
      },
      functionComponentMap: {
        [PROCESS_FUNCTIONS.SETUP_CREDIT_LIMIT]: 'creditLimit',
        [PROCESS_FUNCTIONS.SUBMIT_DUE_DILIGENCE]: 'dueDiligence',
        [PROCESS_FUNCTIONS.ADD_PFI_ONBOARDING]: 'pfiOnboarding',
        [PROCESS_FUNCTIONS.SUBMIT_DIRECTORS_KYC]: 'KYCInformation',
        [PROCESS_FUNCTIONS.UPLOAD_MFA_DOCUMENT]: 'masterFinancingAgreement',
      },
      reworkAllowedPages: [
        'account-officer',
        // 'pfi-onboarding',
        // 'pfi-onboarding-list',
        // PROCESS_FUNCTIONS.SETUP_CREDIT_LIMIT,
        // PROCESS_FUNCTIONS.SUBMIT_DUE_DILIGENCE,
        // PROCESS_FUNCTIONS.ADD_PFI_ONBOARDING,
        // PROCESS_FUNCTIONS.SUBMIT_DIRECTORS_KYC,
        // PROCESS_FUNCTIONS.UPLOAD_MFA_DOCUMENT,
      ],
      selectedApprovalItem: {},
    }
  },
  computed: {
    ...mapGetters({
      corporateInformation: 'operations/getCorporateDetails',
      userDetails: 'auth/getCurrentUser',
      branchOptions: 'operations/branchOptions',
    }),

    repaymentFrom() {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - (this.repaymentSchedulePagination.perPage - 1)
    },
    repaymentTo() {
      return Math.min(this.repaymentFrom + this.repaymentSchedulePagination.perPage - 1, this.repaymentSchedulePagination.totalEntries)
    },
    postingApprovalFrom() {
      return (this.postingApprovalPagination.currentPage * this.postingApprovalPagination.perPage) - (this.postingApprovalPagination.perPage - 1)
    },
    postingApprovalTo() {
      return Math.min(this.postingApprovalFrom + this.postingApprovalPagination.perPage - 1, this.postingApprovalPagination.totalEntries)
    },
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedApprovalItemHeader() {
      return this.approvalItemHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedApprovalHistoryHeader() {
      return this.approvalHistoryHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedpostingApprovalHeader() {
      return this.postingApprovalHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedPaymentScheduleApprovalHeader() {
      return this.paymentScheduleApprovalHeader.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedRepaymentScheduleTableHeaders() {
      return this.repaymentScheduleTableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    documentTypeOptions() {
      return documentTypes.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    translatedApprovalStatusOptions() {
      return approvalStatusOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
    ...mapGetters('tableCache', ['getTableCache']),
    cacheKey() {
      // Use page + perPage + filter as cacheKey
      return JSON.stringify({ page: this.currentPage, perPage: this.perPage, filter: this.filter })
    },
    cachedApprovalsList() {
      return this.getTableCache('pendingApprovals', this.cacheKey)
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchApprovals()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchApprovals()
    },
  },
  mounted() {
    this.fetchApprovals()
    this.fetchUsers()
    this.fetchPermissions()
  },
  methods: {
    ...mapActions({
      getApprovals: 'operations/getPendingApprovalRequests',
      getApproval: 'operations/getApproval',
      processApproval: 'operations/processApproval',
      getUsers: 'operations/getAllUsers',
      getPermissions: 'admin/getAllPermission',
      getDocumentFiles: 'account/getDocumentFilesAction',
      getPaymentSchedule: 'account/getPaymentSchedule',
    }),
    ...mapActions('tableCache', ['setTableCache', 'markTableCacheStale', 'clearTableCache']),
    getPageNumber(index) {
      return (this.repaymentSchedulePagination.currentPage * this.repaymentSchedulePagination.perPage) - this.repaymentSchedulePagination.perPage + index + 1
    },
    getPageNumberIndex(index) {
      return (this.postingApprovalPagination.currentPage * this.postingApprovalPagination.perPage) - this.postingApprovalPagination.perPage + index + 1
    },
    async onViewApprovalHistory(item) {
      this.showSpinner = true
      const response = await this.getApproval({ id: item.id, permission: operationPermissions.VIEW_PENDING_APPROVALS })

      const { data, status } = response

      if (status === 200 && data) {
        this.approvalHistory = data.approvalLogHistory.map(val => ({
          ...val,
          levelAndDescription: `Level ${val.level} ${val.description}`,
        }))
        this.showSpinner = false
      }

      this.$root.$emit('bv::show::modal', 'approval-history-modal')
    },
    getPageKeyToEvaluate(item) {
      if (!item) {
        return null
      }

      const { sourceRoute, functionName } = item

      if (typeof sourceRoute === 'string') {
        const routeParts = sourceRoute.split('/').filter(Boolean)
        if (routeParts && routeParts.length > 1) {
          const pageKeyFromRoute = routeParts[1] // e.g., 'account-officer' from '/operations/account-officer'

          // Explicitly list the routes that should use this sourceRoute logic
          const routesToCheck = ['account-officer', 'pfi-onboarding', 'pfi-onboarding-list']
          if (routesToCheck.includes(pageKeyFromRoute)) {
            return pageKeyFromRoute
          }
        }
      }

      // fall back to functionName if it's a string.
      if (typeof functionName === 'string') {
        return functionName
      }

      return null
    },
    extractPageKey(item) {
      if (!item) {
        return null
      }

      const { sourceRoute, functionName } = item

      // Check for explicit route-based pages
      const routeParts = sourceRoute?.split('/').filter(Boolean) // Filter(Boolean) removes empty strings
      if (routeParts && routeParts.length > 1) {
        const pageKeyFromRoute = routeParts[1] // e.g., 'account-officer' from '/operations/account-officer'
        // You can explicitly list the routes that should trigger this logic
        const routesToCheck = ['account-officer', 'pfi-onboarding', 'pfi-onboarding-list']
        if (routesToCheck.includes(pageKeyFromRoute)) {
          return pageKeyFromRoute
        }
      }

      // Ensure functionName is a string for the includes() check
      if (typeof functionName === 'string') {
        return functionName
      }

      return null
    },
    async onViewRepaymentSchedule() {
      try {
        this.showSpinner = true
        this.isLoadingRepaymentSchedule = true
        this.isDisabledRepaymentSchedule = true

        if (this.isDisburseLoanAccount) {
          this.disburseLoanAmount = toKobo(this.repaymentScheduleData.loanAmount)
        } else {
          this.disburseLoanAmount = this.repaymentScheduleData.loanAmount
        }

        const formData = {
          applicableInterestCode: this.repaymentScheduleData.applicableInterestCode,
          applicableInterestRate: this.repaymentScheduleData.applicableInterestRate,
          applyLoanFees: this.repaymentScheduleData.applyLoanFees,
          interestAccrualMode: this.repaymentScheduleData.interestAccrualMode,
          interestCommencementDate: this.repaymentScheduleData.interestCommencementDate ? this.repaymentScheduleData.interestCommencementDate : null,
          interestFrequency: this.repaymentScheduleData.interestFrequency ? this.repaymentScheduleData.interestFrequency : this.repaymentScheduleData.repaymentFrequency,
          interestRepaymentType: this.repaymentScheduleData.interestRepaymentType ? this.repaymentScheduleData.interestRepaymentType : this.repaymentScheduleData.repaymentOption,
          interestToBeRepaidEvery: this.repaymentScheduleData.interestToBeRepaidEvery ? this.repaymentScheduleData.interestToBeRepaidEvery : this.repaymentScheduleData.toBeRepaidEvery,
          interestInstallment: this.repaymentScheduleData.interestInstallment ? this.repaymentScheduleData.interestInstallment : this.repaymentScheduleData.numberOfInstallment,
          tenure: this.repaymentScheduleData.tenure,
          loanAmount: this.disburseLoanAmount ? Number(this.disburseLoanAmount) : 0,
          loanFeesRequest: this.repaymentScheduleData.loanFees,
          firstRepaymentDate: this.repaymentScheduleData.firstRepaymentDate ? this.repaymentScheduleData.firstRepaymentDate : null,
          allowMoratorium: this.repaymentScheduleData.allowMoratorium,
          moratoriumDuration: this.repaymentScheduleData.moratoriumDuration,
          moratoriumEffect: this.repaymentScheduleData.moratoriumEffect ? this.repaymentScheduleData.moratoriumEffect : null,
          moratoriumFrequency: this.repaymentScheduleData.moratoriumFrequency ? this.repaymentScheduleData.moratoriumFrequency : null,
          penaltyGracePeriod: this.repaymentScheduleData.penaltyGracePeriod,
          principalFrequency: this.repaymentScheduleData.principalFrequency ? this.repaymentScheduleData.principalFrequency : this.repaymentScheduleData.repaymentFrequency,
          principalInstallment: this.repaymentScheduleData.principalInstallment ? this.repaymentScheduleData.principalInstallment : this.repaymentScheduleData.numberOfInstallment,
          principalRepaymentType: this.repaymentScheduleData.principalRepaymentType ? this.repaymentScheduleData.principalRepaymentType : this.repaymentScheduleData.repaymentOption,
          principalToBeRepaidEvery: this.repaymentScheduleData.principalToBeRepaidEvery ? this.repaymentScheduleData.principalToBeRepaidEvery : this.repaymentScheduleData.toBeRepaidEvery,
          productCode: this.repaymentScheduleData.productCode,
          startDate: this.repaymentScheduleData.startDate,
          useProductInterestRate: this.repaymentScheduleData.useProductInterestRate,
        }
        const response = await this.getPaymentSchedule({ formData, permission: operationPermissions.VIEW_PENDING_APPROVALS })
        const { status, data } = response
        if (status === 200) {
          this.repaymentSchedules = data.data.map(item => ({
            ...item,
            fee: toBalance(item.fee),
            interest: toBalance(item.interest),
            paymentDate: toDateWithMonth(item.paymentDate),
            paymentStatus: addSpaceToString(item.paymentStatus),
            principal: toBalance(item.principal),
            totalRepayment: toBalance(item.totalRepayment),
          }))
          this.repaymentSchedulePagination.totalEntries = data.recordCount
          this.exportableRepaymentSchedules = data.data.map(item => ({
            ...item,
          }))
          this.showSpinner = false
          this.isLoadingRepaymentSchedule = false
          this.$root.$emit('bv::show::modal', 'repayment-schedule-modal')
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoadingRepaymentSchedule = false
        this.isDisabledRepaymentSchedule = false
        this.showSpinner = false
      }
    },
    handleDownload(data) {
      const link = document.createElement('a')
      link.href = data
      link.click()
      this.alertSuccess({ text: this.$t('Your request to download file was successful') })
    },
    viewDocumentFile(image, title, fileExtension) {
      this.fileExtension = fileExtension
      this.viewDocumentData = image
      this.viewDocumentModalTitle = title.replace(/([a-zA-Z])(?=[A-Z])/g, '$1 ')
      this.$root.$emit('bv::show::modal', 'view-avatar-modal')
    },
    resetDocumentModal() {
      this.viewDocumentData = ''
      this.viewDocumentModalTitle = ''
    },
    async viewDocumentFileAction() {
      try {
        this.isLoadingDocumentFile = true
        this.isDisabledDocumentFile = true
        const response = await this.getDocumentFiles({ referenceNumber: this.documentIdentifier, permission: operationPermissions.VIEW_PENDING_APPROVALS })
        const { status, data } = response
        if (status === 200) {
          this.documentsFormData = data.data ? data.data.map(item => ({
            url: item.url,
            type: item.typeID,
            fileName: item.type,
            id: item.id,
            fileExtension: item.fileExtension,
          })) : [{
            url: '',
            type: '',
          }]
          this.$root.$emit('bv::show::modal', 'modal-document-files')
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingDocumentFile = false
        this.isDisabledDocumentFile = false
      }
    },
    async fetchUsers() {
      try {
        this.isLoadingInitiatorName = true
        const formData = {
          status: 'Active',
        }
        const response = await this.getUsers({
          formData,
          permission: operationPermissions.VIEW_PENDING_APPROVALS,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.usersOptions = data.data
            // eslint-disable-next-line no-nested-ternary
            .map(item => ({ label: `${item?.firstname ?? ''} ${item?.lastname ?? ''} ${item?.othernames ?? ''}`, value: item.id })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingInitiatorName = false
      }
    },
    async fetchPermissions() {
      try {
        this.isLoadingFunctionName = true
        const response = await this.getPermissions({ permission: operationPermissions.VIEW_PENDING_APPROVALS })
        const { status, data } = response
        if (status === 200) {
          this.functionNameOptions = data.data.filter(item => item.isApprovable).map(item => ({
            label: item.description,
            value: item.id,
          })).sort((a, b) => a.label - b.label)
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingFunctionName = false
      }
    },
    async onSelectApprovalItem(items, activity, val) {
      try {
        this.showSpinner = true
        this.isPaymentSchedule = false
        this.currentFormComponent = null
        this.formProps = {}
        this.entityType = null
        this.isComponentLoading = true
        this.selectedApprovalItem = items

        const response = await this.getApproval({ id: items.id, permission: operationPermissions.VIEW_PENDING_APPROVALS })
        this.approvalTableItems = [
          { label: this.$t('Request ID'), text: items.requestId },
          { label: this.$t('Function Name'), text: items.functionName },
          { label: this.$t('Subject Name'), text: items.functionName },
          { label: this.$t("Initiator's Branch"), text: items.initiatorBranch },
          { label: this.$t('Date Logged'), text: items.dateCreatedFormatted ? items.dateCreatedFormatted : '' },
          { label: this.$t("Initiator's Name"), text: items.initiatorName },
          { label: this.$t('Level'), text: items.level ? items.level : '' },
          { label: this.$t('Description'), text: items.description ? items.description : '' },
          { label: this.$t('Date Approved'), text: items.dateApprovedFormatted ? items.dateApprovedFormatted : '' },
          { label: this.$t('Sanctioned By'), text: items.sanctionedBy },
          { label: this.$t('Approval Status'), text: items.approvalStatus },
        ]
        const { data, status } = response
        if (status === 200 && data) {
          if (items.approvalStatus.toLowerCase() === 'approved' || items.approvalStatus.toLowerCase() === 'declined' || items.approvalStatus.toLowerCase() === 'reworkrequired') {
            this.hasBeenApproved = false
          } else {
            this.hasBeenApproved = true
          }
          this.currentApprovalItem = data

          // Determine the entity type based on the function name or other data in the item
          this.entityType = this.determineEntityType(data)

          if (this.entityType) {
            this.fallbackToDefault = false
            this.enableRecordHistory = false
            this.approvalStatus = items.approvalStatus
            try {
              await this.loadFormComponent(this.entityType)

              this.prepareFormProps(items, activity, val)
              this.isComponentLoading = false
            } catch (componentError) {
              this.alertError({ text: this.$t('Failed to load details view') })
              this.isComponentLoading = false
              this.fallbackToDefault = true
            }
          } else {
            this.fallbackToDefault = true
            this.enableRecordHistory = true
            this.isComponentLoading = false
            if (data.postingType === 'BatchGLandCustomerBackdatingPosting' && data.function.toUpperCase() === 'BACKDATING POSTING') {
              const approvalDataItems = data.approvalData ? JSON.parse(data.approvalData) : null
              const { financialBackdateTo } = approvalDataItems.postingData
              this.approvalTableItems.push({ label: this.$t('Financial Backdate To'), text: financialBackdateTo ? toDateWithYear(financialBackdateTo) : null })
            }
            if (data.postingType === 'BatchGLandCustomerBackdatingPosting' && data.function.toUpperCase() === 'BATCH BACKDATING POSTING') {
              const approvalDataItems = data.approvalData ? JSON.parse(data.approvalData) : null
              const { financialBackdateTo } = approvalDataItems
              this.approvalTableItems.push({ label: this.$t('Financial Backdate To'), text: financialBackdateTo ? toDateWithYear(financialBackdateTo) : null })
            }
            this.isPostingType = data.postingType !== null
            if (this.isPostingType) {
              const approvalItems = data.approvalData ? JSON.parse(data.approvalData) : null
              if (data.postingType === 'BatchJournalUploadPosting') {
                this.postingApprovalItems = approvalItems.payload.map(item => ({
                  ...item,
                  debit: item.debit ? toBalance(item.debit) : '',
                  credit: item.credit ? toBalance(item.credit) : '',
                }))
              } else if (data.postingType === 'BatchJournalToCustomerPosting') {
                this.postingApprovalItems = approvalItems.payload.map(item => ({
                  ...item,
                  debit: item.debit ? toBalance(item.debit) : '',
                  credit: item.credit ? toBalance(item.credit) : '',
                }))
              } else if (data.postingType === 'BatchGLandCustomerBackdatingPosting' && data.function.toUpperCase() === 'BACKDATING POSTING') {
                this.postingApprovalItems = approvalItems.postingEntry.map(item => ({
                  ...item,
                  debit: item.amount && item.recordType.toLowerCase() === 'debit' ? toBalance(item.amount) : '',
                  credit: item.amount && item.recordType.toLowerCase() === 'credit' ? toBalance(item.amount) : '',
                }))
              } else if (data.postingType === 'BatchGLandCustomerBackdatingPosting' && data.function.toUpperCase() === 'BATCH BACKDATING POSTING') {
                this.postingApprovalItems = approvalItems.payload.map(item => ({
                  ...item,
                  debit: item.debit ? toBalance(item.debit) : '',
                  credit: item.credit ? toBalance(item.credit) : '',
                }))
              } else if (data.postingType === 'ReversalPosting') {
                this.postingApprovalItems = approvalItems.reversalOutcome.map(item => ({
                  ...item,
                  debit: item.debit ? toBalance(item.debit) : '',
                  credit: item.credit ? toBalance(item.credit) : '',
                }))
              } else if (data.postingType === 'AccountClosurePosting') {
                this.isPostingType = false
              } else if (data.postingType === 'ChequeDepositPosting') {
                this.isPostingType = false
              } else if (data.postingType === 'FixedDepositLiquidation') {
                this.isPostingType = false
              } else if (data.postingType === 'FixedDepositTopUpPosting') {
                this.isPostingType = false
              } else if (data.postingType === 'ElectronicChannelsPosting') {
                this.isPostingType = false
              } else if (data.postingType === 'LoanPosting') {
                this.isPostingType = false
              } else {
                this.postingApprovalItems = approvalItems.postingEntry.map(item => ({
                  ...item,
                  debit: item.recordType === 'Debit' ? toBalance(item.amount) : '',
                  credit: item.recordType === 'Credit' ? toBalance(item.amount) : '',
                }))
              }
              this.postingApprovalPagination.totalEntries = this.postingApprovalItems.length
            }
            // this.hasBeenApproved = !((items.approvalStatus.toLowerCase() === 'completed' || 'rejected'))
            // this.menuName = items.permission !== null ? items.permission : ''
          }
          this.approvalFormData.id = items.id
          const approvalData = data?.approvalData ? JSON.parse(data.approvalData) : null
          const preApprovedRecord = data.preApprovedRecord ? JSON.parse(data.preApprovedRecord) : null

          if (data.function === 'DISBURSE LOAN') {
            this.isDisburseLoanAccount = true
            this.documentIdentifier = approvalData.documentIdentifier
            this.repaymentScheduleData = approvalData
          }

          this.approvalItems = []
          // eslint-disable-next-line array-callback-return
          Object.entries(approvalData).reduce((accumulator, currentValue) => {
            if (preApprovedRecord) {
              Object.entries(preApprovedRecord).forEach(item => {
                if (item[0].toLowerCase() === currentValue[0].toLowerCase()) {
                  const newVal = {
                    description: currentValue[0],
                    newData: currentValue[0] === 'amount' || currentValue[0] === 'loanAmount' ? toBalance(currentValue[1]) : currentValue[1],
                    previousData: item[1],
                  }
                  const newValues = {
                    ...newVal,
                    newData: newVal.description === 'postingApprovalModel' ? { ...newVal.newData, amount: toBalance(newVal.newData.amount) } : newVal.newData,
                  }
                  this.approvalItems.push(newValues)
                }
                if (data.function === 'MODIFY LOAN ACCOUNT') {
                  this.isLoanAccount = true
                  this.documentIdentifier = approvalData.documentIdentifier
                  this.repaymentScheduleData = approvalData
                }
              })
            } else if (data.function === 'ABRIDGED LOAN') {
              this.isAbridgedLoan = true
              if (typeof currentValue[1] === 'object') {
                const currentValues = currentValue[1]
                const allData = ({ currentValues })
                this.repaymentScheduleData = allData.currentValues
                Object.entries(currentValue[1]).reduce((acc, item) => {
                  const repayVal = {
                    // category: currentValue[0],
                    description: item[0], newData: item[1], previousData: '',
                  }
                  this.approvalItems.push(repayVal)
                  return true
                }, [])
              } else {
                const nonObjectData = {
                  documentIdentifier: currentValue[1],
                }
                const objData = Object.entries(nonObjectData).map(dataValue => ({
                  ...dataValue,
                }))
                // eslint-disable-next-line prefer-destructuring
                this.documentIdentifier = objData[0][1]
                const objectVal = {
                  // category: currentValue[0],
                  description: objData[0][0], newData: objData[0][1], previousData: '',
                }
                this.approvalItems.push(objectVal)
              }
            } else if ((data.function.toUpperCase() === 'MODIFY PAYMENT SCHEDULE') && (currentValue[0] === 'schedules')) {
              this.isPaymentSchedule = true
              this.paymentScheduleApprovalItems = currentValue[1]?.map(item => ({
                ...item,
                fee: item.fee ? toBalance(item.fee) : '',
                interest: item.interest ? toBalance(item.interest) : '',
                paymentDate: item.paymentDate ? toDateWithMonth(item.paymentDate) : '',
                principal: item.principal ? toBalance(item.principal) : '',
              }))
              const approvalDataItems = data.approvalData ? JSON.parse(data.approvalData) : null
              const { initiatedBy, loanAccountNumber } = approvalDataItems
              this.approvalTableItems.push({ label: this.$t('Initiated By'), text: initiatedBy || null })
              this.approvalTableItems.push({ label: this.$t('Loan Account Number'), text: loanAccountNumber || null })
              this.postingApprovalPagination.totalEntries = this.paymentScheduleApprovalItems.length
            } else {
              if (currentValue[0] === 'postingApprovalModel') {
                return
              }
              const finalVal = {
                description: currentValue[0],
                newData: currentValue[0] === 'amount' || currentValue[0] === 'loanAmount' ? toBalance(currentValue[1]) : currentValue[1],
                previousData: '',
              }
              this.approvalItems.push(finalVal)

              if (data.function === 'CREATE LOAN ACCOUNT') {
                this.isLoanAccount = true
                this.documentIdentifier = approvalData.documentIdentifier
                this.repaymentScheduleData = approvalData
              }
            }
          }, [])

          this.$root.$emit('bv::show::modal', 'modal-lg')
        }
      } catch (error) {
        this.alertError({ text: error })
        this.isComponentLoading = false
      } finally {
        this.showSpinner = false
      }
    },
    async handleSubmit(actionType) {
      Object.keys(this.approvalButtonStatus).forEach(key => {
        this.approvalButtonStatus[key] = false
      })

      const actionConfig = {
        2: {
          title: this.$t('Approve'),
          isNoteRequired: '',
          loadingKey: 'isLoadingApprove',
          disableKey: 'isDisableApprove',
        },
        3: {
          title: this.$t('Decline'),
          isNoteRequired: 'required',
          loadingKey: 'isLoadingReJect',
          disableKey: 'isDisableReject',
        },
        4: {
          title: this.$t('Cancel'),
          isNoteRequired: 'required',
          loadingKey: 'isLoadingReWork',
          disableKey: 'isDisableReWork',
        },
        5: {
          title: this.$t('ReworkRequired'),
          isNoteRequired: 'required',
          loadingKey: 'isLoadingReWork',
          disableKey: 'isDisableReWork',
        },
      }

      const config = actionConfig[actionType]
      if (!config) return

      this.title = config.title
      this.isApprovalNoteRequired = config.isNoteRequired
      this.approvalFormData.approvalStatus = actionType

      this.approvalButtonStatus[config.loadingKey] = false
      this.approvalButtonStatus[config.disableKey] = false

      // Validate only if needed (always for required notes, optional for approve)
      if (config.isNoteRequired === 'required' || actionType === 2) {
        this.$refs.approvalRules.validate().then(success => {
          if (success) {
            const areYouSure = this.$t('Are you sure you want to')
            const thisRequest = this.$t('this request?')
            const confirmMessage = actionType === 5
              ? this.$t('Would you like this request to be reworked?')
              : `${areYouSure} ${this.title} ${thisRequest}`
            this.confirm(this.processApprovalAction, { text: confirmMessage })
          }
        })
      } else {
        const areYouSure = this.$t('Are you sure you want to')
        const thisRequest = this.$t('this request?')
        const confirmMessage = `${areYouSure} ${this.title} ${thisRequest}`
        this.confirm(this.processApprovalAction, { text: confirmMessage })
      }
    },
    async processApprovalAction() {
      try {
        if (this.title === 'Approve') {
          this.approvalButtonStatus.isLoadingApprove = true
          this.approvalButtonStatus.isDisableApprove = true
        }
        if (this.title === 'Decline') {
          this.approvalButtonStatus.isLoadingReJect = true
          this.approvalButtonStatus.isDisableReject = true
        }
        if (this.title === 'Cancel' || this.title === 'ReworkRequired') {
          this.approvalButtonStatus.isLoadingReWork = true
          this.approvalButtonStatus.isDisableReWork = true
        }
        const approvalData = this.approvalFormData
        const response = await this.processApproval({ approvalData, permission: operationPermissions.VIEW_PENDING_APPROVALS })
        const { status } = response
        if (status === 200) {
          this.markTableCacheStale('pendingApprovals')
          this.fetchApprovals()
          this.hideModal('modal-lg')
          this.approvalFormData.notes = ''
          const yourRequest = this.$t('Your request to')
          const successText = this.$t('was successful')
          this.alertSuccess({ text: `${this.title === 'ReworkRequired' ? this.$t('Your request was marked as rework successfully') : `${yourRequest} ${this.title} ${this.menuName} ${successText}`}` })
        }
      } catch (error) {
        const errorValue = error.response.data.errors && error.response.data.errors.length > 0 ? error.response.data.errors[0].errorMessage : ''
        this.alertError({ text: errorValue })
      } finally {
        this.approvalButtonStatus.isLoadingReWork = false
        this.approvalButtonStatus.isDisableReWork = false
        this.approvalButtonStatus.isLoadingReject = false
        this.approvalButtonStatus.isDisableReject = false
        this.approvalButtonStatus.isLoadingApprove = false
        this.approvalButtonStatus.isDisableApprove = false
      }
    },
    async fetchApprovals() {
      try {
        this.isBusy = true
        const response = await this.getApprovals({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
        })
        const { status, data } = response
        if (status === 200 && data && Array.isArray(data.data)) {
          const mappedData = data.data.map(item => ({
            ...item,
            initiatorName: formatFullName(item.initiator),
            dateLogged: item.dateCreatedFormatted ?? '',
            levelAndDescription: `Level ${item.level ?? ''}${item.description ? ` - ${item.description}` : ''}`,
            dateApproved: item.dateApprovedFormatted ?? '',
            initiatorBranch: item.initiator?.branch ?? '',
            requestId: item.reference ?? '',
            functionName: item.function ?? '',
            sanctionedBy: formatFullName(item.approver),
          }))

          this.approvalList = mappedData
          this.totalCount = data.totalItems
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
      }
    },

    determineEntityType(item) {
      const sourceRoute = item?.sourceRoute?.toLowerCase() || ''
      const itemFunction = item?.function || ''

      const matchedEntry = Object.entries(this.functionComponentMap).find(
        ([funcConstant]) => itemFunction === funcConstant,
      )

      if (matchedEntry) {
        const [, componentName] = matchedEntry // Destructure the matched entry
        return componentName
      }

      if (sourceRoute.includes('/account-officer')) {
        return 'accountOfficer'
      }

      // Return null if no matching type is determined
      return null
    },

    loadFormComponent(entityType) {
      if (!this.formRegistry[entityType]) {
        const text = this.$t('No form component registered for entity type:')
        return Promise.reject(new Error(`${text} ${entityType}`))
      }

      this.currentFormComponent = null // Clear current component

      return this.formRegistry[entityType]()
        .then(module => {
          this.currentFormComponent = module.default || module
          return this.currentFormComponent
        })
    },

    prepareFormProps(item, activity, val) {
      // Set up props for the dynamic component based on item data
      // This will vary depending on the component being loaded
      this.formProps = {
        mode: 'view',
        data: JSON.parse(item.approvalData) || {},
        initialFormData: JSON.parse(item.approvalData) || {},
        isEdit: val === 'view',
      }
    },

    handleFormUpdate(updatedData) {
      this.formData = updatedData.formData
    },
    // Make sure to reset these when you close the modal
    resetDynamicComponent() {
      this.currentFormComponent = null
      this.formProps = {}
      this.entityType = null
    },
    resetFilters() {
      this.filter = { ...null }
      this.fetchApprovals()
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchApprovals()
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-image{
    border: 2px dashed #DCD9D9;
    position: relative;
    width: 250px;
    height: 250px
}
.format {
    color: #999999 !important;
}
form input[type=file]{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}
.upload-instruction{
  padding-top: 22%;
  color: #000;
  text-align: center;
}
.trash {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}
.view-details {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.approval-table{
  padding-bottom: 65px !important;
}
@media print {
  html, body {
     height: 99%;
     page-break-after: avoid !important;
     page-break-before: avoid !important;
     visibility:hidden;
  }
}
</style>
